import { Box, Card, CardContent, Chip, Grid, Typography, } from "@mui/material";
import { DadoValorPrinter } from "../../../../../../components/BasicComponents/DisplayDados/DadoValorPrinter";
import { formatarValorMonetario } from "../../../../../../helpers/masks";
import { IDetalheHistoricoMercadoria } from "../../../../../../types/api/estoque/detalhe-historico-mercadoria";
import moment from "moment";


export default function CardNotaFiscal({ data }: CardNotaFiscalProps) {
    return (
        <Card sx={{ mb: 2 }}>
            <CardContent>
                <Typography variant="h6" component="h2" gutterBottom>
                    Nota fiscal
                </Typography>

                <Grid container spacing={2}>
                    <Grid size={{xs: 12, sm: 4}}>
                        <DadoValorPrinter
                            titulo="Espécie/Número/Série"
                            valor={`NF${data.nf_numero}/${data.nf_serie}`}
                        />
                    </Grid>
                    <Grid size={{xs: 12, sm: 4}}>
                        <DadoValorPrinter
                            titulo="Emitente"
                            valor={`${data.nf_nome_emissor}`}
                        />
                    </Grid>
                    <Grid size={{xs: 12, sm: 4}}>
                        <Box sx={{ textAlign: { xs: 'left', sm: 'right' } }}>
                            <Typography variant="body2" color="text.secondary">
                                Total
                            </Typography>
                            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                {formatarValorMonetario(data.nf_valor)}
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid size={{xs: 12, sm: 4}}>
                        <DadoValorPrinter
                            titulo="Natureza da operação"
                            valor={data.natureza_operacao || '-'}
                        />
                    </Grid>
                    <Grid size={{xs: 12, sm: 4}}>
                        <DadoValorPrinter
                            titulo="Destinatário"
                            valor={`${data.nf_nome_destinatario ?? '-'}`}
                        />
                    </Grid>
                    <Grid size={{xs: 12, sm: 4}}>
                        <Box sx={{
                            display: 'flex',
                            justifyContent: { xs: 'flex-start', sm: 'flex-end' },
                            alignItems: 'flex-start',
                            height: '100%'
                        }}>
                            <Chip
                                label={getStatusChipProps(data.status).label}
                                sx={getStatusChipProps(data.status).sx}
                                color="default"
                            />
                        </Box>
                    </Grid>

                    <Grid size={{xs: 12, sm: 4}}>
                        <DadoValorPrinter
                            titulo="Data do recebimento"
                            valor={data.data_recebimento ? moment(data.data_recebimento).format("DD/MM/YYYY") : '-'}
                        />
                    </Grid>
                    <Grid size={{xs: 12, sm: 8}}>
                        <DadoValorPrinter
                            titulo="Responsável pelo recebimento"
                            valor={`${data.recebido_por ?? '-'}`}
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

export interface CardNotaFiscalProps {
    data: IDetalheHistoricoMercadoria;
}

function getStatusChipProps(status: string) {
    let background = "#E0E0E0";
    let textColor = "#444";
    if (status === "Análise de divergência") {
        background = "#FFD600";
        textColor = "#444";
    } else if (status === "Aguardando chegada") {
        background = "#2196F3";
        textColor = "#fff";
    } else if (status === "Recebido com sucesso") {
        background = "#2E7D32";
        textColor = "#fff";
    }
    return {
        sx: {
            fontWeight: "bold",
            fontSize: "0.8125rem",
            px: 2,
            height: 28,
            borderRadius: 5,
            background,
            color: textColor,
        },
        color: "default",
        label: status,
    };
}